import React from "react";
import * as THREE from "three";
import { Scene } from "../../../../../Types";
import { useFrame } from "@react-three/fiber";
import { useController } from "@react-three/xr";
import { useXRPopupStore } from "../XRHotspots";

const PopupsBackground = ({ currentScene }: { currentScene: Scene }) => {
  const gaze = useController("none");
  const leftC = useController("left");
  const rightC = useController("right");

  const xrPop = useXRPopupStore();

  const [autoclose, setAutoclose] = React.useState<boolean>(false);
  const closeRef = React.useRef<boolean>(false);

  const closePopup = React.useCallback(() => {
    if (gaze) {
      if (autoclose) {
        return xrPop.closePop();
      }
    } else return xrPop.closePop();
  }, [autoclose, gaze, xrPop]);

  useFrame((state) => {
    state.camera.getWorldDirection(dir);
    state.camera.getWorldPosition(pos);

    if (xrPop.isOpen) {
      const openPop = currentScene.hotspots.find(
        (one) => one.id === xrPop.target
      );

      const gazeDir = dir.add(pos);

      const openPopPos = new THREE.Vector3(openPop?.x, openPop?.y, openPop?.z);
      openPopPos.normalize();

      if (gazeDir.distanceTo(openPopPos) > 0.7) {
        if (!autoclose) {
          setAutoclose(true);
          // closeRef.current = true
        }

        return;
      } else setAutoclose(false);
    }
  });

  if (xrPop.isOpen) {
    return (
      <mesh position={[0, 0, 0]} renderOrder={1} name="sfera trasparente">
        <sphereGeometry args={[250, 16, 8]} />
        <meshBasicMaterial
          // wireframe
          color={"#032b43"}
          side={THREE.DoubleSide}
          depthTest={false}
          transparent
          opacity={0.75}
        />
      </mesh>
    );
  }
};

export default PopupsBackground;

const pos = new THREE.Vector3();
const dir = new THREE.Vector3();
